export const ACCOUNTS_INSIGHTS_LOADING = 'ACCOUNTS_INSIGHTS_LOADING'
export const ACCOUNTS_INSIGHTS_NATIONALITY = 'ACCOUNTS_INSIGHTS_NATIONALITY'
export const ACCOUNTS_INSIGHTS_TYPE = 'ACCOUNTS_INSIGHTS_TYPE'
export const ACCOUNTS_INSIGHTS_SIZE = 'ACCOUNTS_INSIGHTS_SIZE'
export const ACCOUNTS_INSIGHTS_AGE = 'ACCOUNTS_INSIGHTS_AGE'
export const ACCOUNTS_INSIGHTS_TOP = 'ACCOUNTS_INSIGHTS_TOP'
export const GET_ACCOUNTS_INSIGHTS_CONTACTS = 'GET_ACCOUNTS_INSIGHTS_CONTACTS'
export const CLEAR_ACCOUNTS_INSIGHTS = 'CLEAR_ACCOUNTS_INSIGHTS'
